import fuzzy from 'fuzzy';

function joinKeys<T>(item: T, keys: any): string {
  return keys.reduce((all: string, k: any) => {
    const n = typeof k === 'function' ? k(item) : ((item as any)[k] as any);
    return `${all} ${n}`;
  }, '');
}

const DEFAULT_FIELDS = ['name'];

export default function filterCollection<T>(opts: { fields: Array<string> }) {
  const { fields = DEFAULT_FIELDS } = opts;

  return (collection: Array<T>, query: string): Array<T> => {
    if (query.length > 0) {
      const collectionSearchQueries = collection.map((item) => joinKeys<T>(item, fields));
      const output = fuzzy.filter(query, collectionSearchQueries);
      return output.map((i) => collection[i.index]);
    } else {
      return collection;
    }
  };
}
